import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GetAssayAnalite_assayAnalite } from '@modelos/interfaces/operation-result-types';
import { AssayAnaliteService } from '@servicios/assay/assayAnalite.service';
import { NotificacionesService } from '@servicios/notificaciones.service';

@Component({
    selector: 'app-assay-analite-order',
    templateUrl: './assay-analite-order.component.html',
    styleUrls: ['./assay-analite-order.component.css'],
    standalone: false
})


export class AssayAnaliteOrderComponent implements OnInit {

  constructor(
    public config: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private aas: AssayAnaliteService,
    private ns: NotificacionesService
  ) { }

  analites:IAnaliteOrder [] = []
  isSaving = false
  spinnerMessage = 'Guardando...'

  ngOnInit(): void {
    if (this.config.data?.analites) {
      this.config.data.analites.forEach((analite, i)=> {
        this.analites.push({id: analite.id, analite: analite.analite.name, index: analite.index})
      })
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.analites, event.previousIndex, event.currentIndex);
  }

  disbledSaveButton(){
    return this.isSaving
  }

  closeDialog(){
    this.dialogRef.close()
  }

  _reorderAnalites (analites: IAnaliteOrder []) {
    this.isSaving = true
    this.aas.reorderAnalites(analites, this.config.data.assayId).subscribe({
      next: ()=> {
        this.isSaving = false
        this.ns.emitMessage('Orden determinaciones modificado')
        this.dialogRef.close(true)
      },
      error: ()=> {
        this.isSaving = false
      }
    })
  }
}


export interface IAnaliteOrder {
  id: string,
  analite: string,
  index: number
}
